import 'core-js/fn/object/assign'
import ReactGA from 'react-ga'
import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { createHashHistory } from 'history'
import { Redirect, browserHistory, Router, Route, IndexRoute, useRouterHistory } from 'react-router'
import { syncHistoryWithStore, routerReducer } from 'react-router-redux'
import { createStore, combineReducers, applyMiddleware } from 'redux'
import thunkMiddleware from 'redux-thunk'
import {getStoredState, persistStore, autoRehydrate} from 'redux-persist'
import createLogger from 'redux-logger'
import * as reducers from 'reducers'
import App from 'components/App'

// pages
import Home from 'components/Home'
import OurStory from 'components/OurStory'
import Camps from 'components/Camps'
import House from 'components/House'
import Digital from 'components/Digital'
import GetInvolved from 'components/GetInvolved'
import GalleryIndex from 'components/Gallery/GalleryIndex'
import GalleryOverview from 'components/Gallery/GalleryOverview'
import Camp2016PhotoFeed from 'components/Gallery/Camp2016PhotoFeed'
import Sempai from 'components/Sempai'
import Kohai from 'components/Kohai'

if(process.env.NODE_ENV !== 'production') {
  //whyDidYouUpdate(React)
}

const reducer = combineReducers({
  ...reducers,
  routing: routerReducer
})
const persistConfig = {
  skipRestore: false,
  whitelist:['persist']
}
getStoredState(persistConfig, (err, initialState) => {
  const store = createStore(
    reducer,
    initialState,
    applyMiddleware(thunkMiddleware, createLogger())
  )
  persistStore(store, persistConfig)
  const history = syncHistoryWithStore(browserHistory, store)

  // Google Analytics
  if (process.env.NODE_ENV === 'production') {
    console.log('react ga initialize')
    ReactGA.initialize('UA-87955809-1')
  }

  var onRouteUpdate = () => {
    if (!window.location.hash) {
      window.scrollTo(0, 0)
    }
    // Google Analytics-log the current pathname, only if we're in a production environment.
    if (process.env.NODE_ENV === 'production') {
      ReactGA.set({ page: window.location.pathname })
      ReactGA.pageview(window.location.pathname)
    }
  }

  /*
            <Route path='camp/2016' component={Camp2016Index}>
            <Route path=':campid' component={Camp2016PhotoFeed}/>
          </Route>
          <Route path='photos/:album' component={PhotoList}>
            <Route path=':photoid' component={Photo}/>
          </Route>

  */
  // <Route exact path=':year' component={GalleryOverview}/>
  // <Route exact path=':year/:campid' component={Camp2016PhotoFeed}/>

  // <Route path='/gallery(/:year)(/:campid)' component={GalleryIndex} />

  // ReactDOM.render(
  //   <Provider store={store} >
  //     <Router onUpdate={onRouteUpdate} history={history}>
  //       <Route path='/' component={App}>
  //         <IndexRoute component={Home} />
  //         <Route path='/our-story' component={OurStory}/>
  //         <Route path='/camps' component={Camps} />
  //         <Route path='/newyork' component={House} />
  //         <Route path='/kohai' component={Kohai}/>
  //         <Route path='/gallery(/:year)(/:campid)' component={GalleryIndex} />
  //         <Route path='/digital' component={Digital}/>
  //         <Route path='/get-involved' component={GetInvolved}/>
  //         <Redirect from='/apply' to='/camps'/>
  //         <Redirect from='*' to='/'/>
  //       </Route>
  //     </Router>
  //   </Provider>,
  //   document.getElementById('app')
  // )

ReactDOM.render(
    <Provider store={store} >
      <Router onUpdate={onRouteUpdate} history={history}>
        <Route path='/' component={App}>
          <IndexRoute component={GalleryIndex} />
          <Route path='/gallery(/:year)(/:campid)' component={GalleryIndex} />
          <Redirect from='*' to='/'/>
        </Route>
      </Router>
    </Provider>,
    document.getElementById('app')
  )

  // <Route path='/sempai' component={Sempai}/>
  //unlisten()
})



// WEBPACK FOOTER //
// ./src/index.js